<script lang="ts">
  import VerticalCenter from './verticalCenter.svelte';
  import ErrorMark from './errorMark.svelte';

  export let error: string;
</script>

<VerticalCenter>
  <div>
    <ErrorMark />
    <h1>{error}</h1>
  </div>
</VerticalCenter>

<style>
  h1 {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin: 15px 0px 0px 0px;
  }
</style>
